<template>
<div class="chapter">
<div class="inner_page">
<p class="p1"><span class="t1">Readers love</span></p>
<p class="p0"><span class="t2">L.J. L</span><span class="t3">A</span><span class="t2">B</span><span class="t3">ARTHE</span></p>
<p class="p2"><img alt="img1.jpg" src="Images/img1.jpg"/></p>
<p class="p3"><span class="t5">City of Jade</span></p>
<p class="p4">“I enjoyed it. I liked our main characters and… the heroes and side characters are interesting…”</p>
<p class="p5">—All About Romance</p>
<p class="p6"><span class="t5">The Crystal Lake</span></p>
<p class="p4">“L.J. LaBarthe is a master story teller and this series is a must read! Once you do, you will want to revisit it often, I know I do!”</p>
<p class="p5">—Top 2 Bottom Reviews</p>
<p class="p6"><span class="t5">A Shot in the Dark</span></p>
<p class="p4">“Intense, fast paced and well written. Great read.”</p>
<p class="p5">—MM Good Book Reviews</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 002.vue?7b9e681e